<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
document.addEventListener('DOMContentLoaded', function() {
  const links = document.links;
  for (let i = 0; i < links.length; i++) {
    const link = links[i];
    if (link.hostname !== window.location.hostname && link.hostname !== '' && link.hostname !== 'account-ret-eu.gflcosmetics.com') {
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
    }
  }
});
  
function sendtome(formemail,variantid,varianturl){
  $.post( "https://zamliy3.zamliy.com/oos.php?prid=X&variantid="+variantid+"&email="+formemail+"&mySite=GFLEU&url="+varianturl, function( data ) {
    $( ".result" ).html( data );
  });
}